import {GetSeferData}   from "SeferPetach/GetData";


export async function getPatternList() {
    var args = {
        STATUS_ID:          [1,6],
        DT_INIT:            '1970-01-01 00:00:00',
        DT_FN:              '2050-12-31 23:59:59'
    };
    var payload = await GetSeferData("pf1", args);
    return (payload);
}
export async function getQuestionList() {
    var args = {
        QUESTION_TYPES:     '1,2,3,4,5,6',
        QUESTION_STATUS:    '1',
        REQ_PT:             'Y',
        REQ_EN:             'Y',
        REQ_ES:             'Y',
        DT_INIT:            '1970-01-01 00:00:00',
        DT_FN:              '2050-12-31 23:59:59'
    };
    var payload = await GetSeferData("qf1", args);
    return (payload);
}
export async function getPatternByID(pattern_id){
    var args = {
        'PATTERN_ID': pattern_id
    };
    var payload = await GetSeferData("pf2", args);
    return (payload);
}
export async function updatePattern(obj){
    var args = obj;
    var payload = await GetSeferData("pf3", args);
    return (payload);
}
export async function deletePattern(pattern_id){
    var args = {
        'PATTERN_ID': pattern_id
    };
    var payload = await GetSeferData("pf4", args);
    return (payload);
}
export async function getPatternUsers(pattern_id){
    var args = {
        'PATTERN_ID': pattern_id
    };
    var payload = await GetSeferData("pf5", args);
    return (payload);
}
export async function insertPatternUser(pattern_id, user_id){
    var args = {
        'PATTERN_ID': pattern_id,
        'USER_ID': user_id
    };
    var payload = await GetSeferData("pf6", args);
    return (payload);
}
export async function removePatternUser(pattern_id, user_id){
    var args = {
        'PATTERN_ID': pattern_id,
        'USER_ID': user_id
    };
    var payload = await GetSeferData("pf7", args);
    return (payload);
}